export const playoffFormattedData = [
  [
    {
      id: '345342',
      order: 1,
      results: [
        {
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              value: '4',
              drawOrder: 1,
            },
            {
              id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
              value: '2',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
          name: 'Memphis Grizzlies',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MEM',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
          name: 'Minnesota Timberwolves',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2bded34b-c5b8-40f3-8735-34bf61d833c9.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/90fc9fac-f3a3-4315-9136-a15ce8840194.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MIN',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: 'd6df4250-7716-47fe-9d25-ade518020f86',
          results: [
            {
              participants: [
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '117',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
                  value: '130',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
              name: 'Minnesota Timberwolves',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2bded34b-c5b8-40f3-8735-34bf61d833c9.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/90fc9fac-f3a3-4315-9136-a15ce8840194.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-16T19:30:00Z',
        },
        {
          id: '1acd59ee-55b7-4721-8082-99386ff022f7',
          results: [
            {
              participants: [
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '124',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
                  value: '96',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
              name: 'Minnesota Timberwolves',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2bded34b-c5b8-40f3-8735-34bf61d833c9.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/90fc9fac-f3a3-4315-9136-a15ce8840194.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-20T00:40:00Z',
        },
        {
          id: '481a8144-a755-443e-8d59-056b9172cd67',
          results: [
            {
              participants: [
                {
                  id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
                  value: '95',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '104',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
              name: 'Minnesota Timberwolves',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2bded34b-c5b8-40f3-8735-34bf61d833c9.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/90fc9fac-f3a3-4315-9136-a15ce8840194.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-21T23:30:00Z',
        },
        {
          id: '5efa4c4e-b242-4800-8bcc-7f46030187c4',
          results: [
            {
              participants: [
                {
                  id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
                  value: '119',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '118',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
              name: 'Minnesota Timberwolves',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2bded34b-c5b8-40f3-8735-34bf61d833c9.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/90fc9fac-f3a3-4315-9136-a15ce8840194.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-24T02:00:00Z',
        },
        {
          id: '7be20c1c-1f1f-4ef1-a754-83c504750e36',
          results: [
            {
              participants: [
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '111',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
                  value: '109',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
              name: 'Minnesota Timberwolves',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2bded34b-c5b8-40f3-8735-34bf61d833c9.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/90fc9fac-f3a3-4315-9136-a15ce8840194.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-26T23:30:00Z',
        },
        {
          id: 'ebead491-762e-4f01-9996-d642c84f0862',
          results: [
            {
              participants: [
                {
                  id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
                  value: '106',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '114',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '48b9a404-bdfc-4057-ab8b-c2b801d2ac44',
              name: 'Minnesota Timberwolves',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2bded34b-c5b8-40f3-8735-34bf61d833c9.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/90fc9fac-f3a3-4315-9136-a15ce8840194.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-30T01:00:00Z',
        },
      ],
      childObjectId: '345338',
    },
    {
      id: '345343',
      order: 2,
      results: [
        {
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              value: '4',
              drawOrder: 1,
            },
            {
              id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
              value: '1',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
          name: 'Golden State Warriors',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'GSW',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
          name: 'Denver Nuggets',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4f25c49b-3950-418e-a353-ef93a5ac07ee.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/fe7e6ed0-18a3-489d-957b-32ecd6e3d5cc.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'DEN',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '577179d6-2824-40cb-85eb-7a83ad563358',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '123',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
                  value: '107',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
              name: 'Denver Nuggets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4f25c49b-3950-418e-a353-ef93a5ac07ee.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/fe7e6ed0-18a3-489d-957b-32ecd6e3d5cc.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DEN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-17T00:30:00Z',
        },
        {
          id: '40a67d8d-0c72-4cf2-be12-e45ad9330773',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '126',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
                  value: '106',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
              name: 'Denver Nuggets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4f25c49b-3950-418e-a353-ef93a5ac07ee.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/fe7e6ed0-18a3-489d-957b-32ecd6e3d5cc.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DEN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-19T02:00:00Z',
        },
        {
          id: 'a8cf5573-47a5-4a1b-92c6-0aa145387000',
          results: [
            {
              participants: [
                {
                  id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
                  value: '113',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '118',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
              name: 'Denver Nuggets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4f25c49b-3950-418e-a353-ef93a5ac07ee.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/fe7e6ed0-18a3-489d-957b-32ecd6e3d5cc.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DEN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-22T02:00:00Z',
        },
        {
          id: 'fb232fce-0551-4ad8-9101-250059bf1f47',
          results: [
            {
              participants: [
                {
                  id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
                  value: '126',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '121',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
              name: 'Denver Nuggets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4f25c49b-3950-418e-a353-ef93a5ac07ee.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/fe7e6ed0-18a3-489d-957b-32ecd6e3d5cc.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DEN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-24T19:30:00Z',
        },
        {
          id: 'ed3aa278-b61b-4087-b14c-2b7343884377',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '102',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
                  value: '98',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'ac0b7f96-cb83-4d3f-a6be-66565537e841',
              name: 'Denver Nuggets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4f25c49b-3950-418e-a353-ef93a5ac07ee.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/fe7e6ed0-18a3-489d-957b-32ecd6e3d5cc.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DEN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-28T02:00:00Z',
        },
      ],
      childObjectId: '345338',
    },
    {
      id: '345345',
      order: 3,
      results: [
        {
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              value: '4',
              drawOrder: 1,
            },
            {
              id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
              value: '2',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
          name: 'Phoenix Suns',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'PHX',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
          name: 'New Orleans Pelicans',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/3acdaa71-6b9f-4067-8608-4578b1e02f38.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e9276533-a3c1-479c-b523-44c1ff8f1086.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'NOP',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '34171698-de98-42bb-af17-cfd90709500e',
          results: [
            {
              participants: [
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '110',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
                  value: '99',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
              name: 'New Orleans Pelicans',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/3acdaa71-6b9f-4067-8608-4578b1e02f38.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e9276533-a3c1-479c-b523-44c1ff8f1086.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'NOP',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-18T01:00:00Z',
        },
        {
          id: '2e02bcf1-deab-4878-bacd-12c98694d3b0',
          results: [
            {
              participants: [
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '114',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
                  value: '125',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
              name: 'New Orleans Pelicans',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/3acdaa71-6b9f-4067-8608-4578b1e02f38.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e9276533-a3c1-479c-b523-44c1ff8f1086.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'NOP',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-20T02:00:00Z',
        },
        {
          id: '5ab904b4-7cdc-4be3-8d2d-273115227b0c',
          results: [
            {
              participants: [
                {
                  id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
                  value: '111',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '114',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
              name: 'New Orleans Pelicans',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/3acdaa71-6b9f-4067-8608-4578b1e02f38.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e9276533-a3c1-479c-b523-44c1ff8f1086.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'NOP',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-23T01:30:00Z',
        },
        {
          id: '1d91a8d9-5b23-4ca7-9b57-a1739b7944f3',
          results: [
            {
              participants: [
                {
                  id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
                  value: '118',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '103',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
              name: 'New Orleans Pelicans',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/3acdaa71-6b9f-4067-8608-4578b1e02f38.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e9276533-a3c1-479c-b523-44c1ff8f1086.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'NOP',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-25T01:30:00Z',
        },
        {
          id: 'bb3e4e59-c932-4a2f-b69c-9635c2d01150',
          results: [
            {
              participants: [
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '112',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
                  value: '97',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
              name: 'New Orleans Pelicans',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/3acdaa71-6b9f-4067-8608-4578b1e02f38.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e9276533-a3c1-479c-b523-44c1ff8f1086.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'NOP',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-27T02:00:00Z',
        },
        {
          id: 'b05d7505-6d46-4bca-828d-0d3d54693bd5',
          results: [
            {
              participants: [
                {
                  id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
                  value: '109',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '115',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'd19632d9-c0fb-4fc7-8df9-91cf1b15cdaf',
              name: 'New Orleans Pelicans',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/3acdaa71-6b9f-4067-8608-4578b1e02f38.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e9276533-a3c1-479c-b523-44c1ff8f1086.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'NOP',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-28T23:30:00Z',
        },
      ],
      childObjectId: '345339',
    },
    {
      id: '345344',
      order: 4,
      results: [
        {
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              value: '4',
              drawOrder: 1,
            },
            {
              id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
              value: '2',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
          name: 'Dallas Mavericks',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'DAL',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
          name: 'Utah Jazz',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d25ae473-f857-4852-b541-f5e7999b7472.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c6fc7756-fb9d-4f35-84eb-b505aea4a264.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'UTA',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '43b60819-707c-4f9e-b724-9913e7292afe',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '93',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
                  value: '99',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
              name: 'Utah Jazz',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d25ae473-f857-4852-b541-f5e7999b7472.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c6fc7756-fb9d-4f35-84eb-b505aea4a264.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'UTA',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-16T17:00:00Z',
        },
        {
          id: '6c0f89a3-dd0d-48da-9965-f8b65ac10612',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '110',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
                  value: '104',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
              name: 'Utah Jazz',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d25ae473-f857-4852-b541-f5e7999b7472.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c6fc7756-fb9d-4f35-84eb-b505aea4a264.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'UTA',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-19T00:30:00Z',
        },
        {
          id: '487ba445-1c0f-4c8c-939f-681b778474ab',
          results: [
            {
              participants: [
                {
                  id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
                  value: '118',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '126',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
              name: 'Utah Jazz',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d25ae473-f857-4852-b541-f5e7999b7472.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c6fc7756-fb9d-4f35-84eb-b505aea4a264.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'UTA',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-22T01:00:00Z',
        },
        {
          id: '432c4ba7-4594-4ba2-8405-8f6b178f163f',
          results: [
            {
              participants: [
                {
                  id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
                  value: '100',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '99',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
              name: 'Utah Jazz',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d25ae473-f857-4852-b541-f5e7999b7472.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c6fc7756-fb9d-4f35-84eb-b505aea4a264.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'UTA',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-23T20:30:00Z',
        },
        {
          id: '47255e61-faae-4169-a5a8-1ef1cec8512e',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '102',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
                  value: '77',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
              name: 'Utah Jazz',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d25ae473-f857-4852-b541-f5e7999b7472.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c6fc7756-fb9d-4f35-84eb-b505aea4a264.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'UTA',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-26T01:30:00Z',
        },
        {
          id: '65ebb838-322c-48df-825f-0fd4abfd98d5',
          results: [
            {
              participants: [
                {
                  id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
                  value: '96',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '98',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '60407999-f73c-45f6-b7ba-ff6361372ae9',
              name: 'Utah Jazz',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d25ae473-f857-4852-b541-f5e7999b7472.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c6fc7756-fb9d-4f35-84eb-b505aea4a264.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'UTA',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-29T02:00:00Z',
        },
      ],
      childObjectId: '345339',
    },
    {
      id: '345347',
      order: 5,
      results: [
        {
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              value: '4',
              drawOrder: 1,
            },
            {
              id: '669db331-932e-4696-8f67-2c11c3f0c27f',
              value: '1',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '6dc732d8-3910-40da-a6ce-ca5741307250',
          name: 'Miami Heat',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MIA',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '669db331-932e-4696-8f67-2c11c3f0c27f',
          name: 'Atlanta Hawks',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/25a2edd4-bf2c-4aa1-aef0-714108b364e5.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/aabd83b6-feb0-4187-bb6d-75db8c218f5e.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'ATL',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: 'e1b148c9-5633-4a8e-89cc-573450edd61c',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '115',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '669db331-932e-4696-8f67-2c11c3f0c27f',
                  value: '91',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '669db331-932e-4696-8f67-2c11c3f0c27f',
              name: 'Atlanta Hawks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/25a2edd4-bf2c-4aa1-aef0-714108b364e5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/aabd83b6-feb0-4187-bb6d-75db8c218f5e.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'ATL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-17T17:00:00Z',
        },
        {
          id: 'cd764af9-e410-4af2-b59a-d4dc9328caf6',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '115',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '669db331-932e-4696-8f67-2c11c3f0c27f',
                  value: '105',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '669db331-932e-4696-8f67-2c11c3f0c27f',
              name: 'Atlanta Hawks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/25a2edd4-bf2c-4aa1-aef0-714108b364e5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/aabd83b6-feb0-4187-bb6d-75db8c218f5e.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'ATL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-19T23:30:00Z',
        },
        {
          id: 'c68fa730-d42f-4b50-bef7-a116e5a34898',
          results: [
            {
              participants: [
                {
                  id: '669db331-932e-4696-8f67-2c11c3f0c27f',
                  value: '111',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '110',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '669db331-932e-4696-8f67-2c11c3f0c27f',
              name: 'Atlanta Hawks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/25a2edd4-bf2c-4aa1-aef0-714108b364e5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/aabd83b6-feb0-4187-bb6d-75db8c218f5e.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'ATL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-22T23:00:00Z',
        },
        {
          id: '6c87540c-6ac0-46b6-9d64-b89c4b7a8911',
          results: [
            {
              participants: [
                {
                  id: '669db331-932e-4696-8f67-2c11c3f0c27f',
                  value: '86',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '110',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '669db331-932e-4696-8f67-2c11c3f0c27f',
              name: 'Atlanta Hawks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/25a2edd4-bf2c-4aa1-aef0-714108b364e5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/aabd83b6-feb0-4187-bb6d-75db8c218f5e.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'ATL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-24T23:00:00Z',
        },
        {
          id: 'd8396a0c-09af-4fd9-a897-a5b9b5c9bf1c',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '97',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '669db331-932e-4696-8f67-2c11c3f0c27f',
                  value: '94',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '669db331-932e-4696-8f67-2c11c3f0c27f',
              name: 'Atlanta Hawks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/25a2edd4-bf2c-4aa1-aef0-714108b364e5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/aabd83b6-feb0-4187-bb6d-75db8c218f5e.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'ATL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-26T23:00:00Z',
        },
      ],
      childObjectId: '345340',
    },
    {
      id: '345346',
      order: 6,
      results: [
        {
          participants: [
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              value: '4',
              drawOrder: 1,
            },
            {
              id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
              value: '2',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
          name: 'Philadelphia 76ers',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'PHI',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
          name: 'Toronto Raptors',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2561e3a6-cc30-47f4-b38b-5ddf498e475d.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/cda06e67-2f86-4cc1-a0ce-b81bda886d52.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'TOR',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '76c64eae-2213-456b-954d-dab834bf09d0',
          results: [
            {
              participants: [
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '131',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
                  value: '111',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
              name: 'Toronto Raptors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2561e3a6-cc30-47f4-b38b-5ddf498e475d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/cda06e67-2f86-4cc1-a0ce-b81bda886d52.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'TOR',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-16T22:00:00Z',
        },
        {
          id: '0057820b-0b2a-4317-9408-26533d7ddb43',
          results: [
            {
              participants: [
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '112',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
                  value: '97',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
              name: 'Toronto Raptors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2561e3a6-cc30-47f4-b38b-5ddf498e475d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/cda06e67-2f86-4cc1-a0ce-b81bda886d52.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'TOR',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-18T23:30:00Z',
        },
        {
          id: '95c455e7-7a59-48ac-9570-08af464f210a',
          results: [
            {
              participants: [
                {
                  id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
                  value: '101',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '104',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '54',
            name: 'Finished after overtime',
            type: 'FINISHED',
            shortName: 'FOT',
            entityType: 'status',
          },
          participants: [
            {
              id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
              name: 'Toronto Raptors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2561e3a6-cc30-47f4-b38b-5ddf498e475d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/cda06e67-2f86-4cc1-a0ce-b81bda886d52.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'TOR',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-21T00:00:00Z',
        },
        {
          id: '104bfb2d-011e-47c6-a9f6-06f5256c8965',
          results: [
            {
              participants: [
                {
                  id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
                  value: '110',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '102',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
              name: 'Toronto Raptors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2561e3a6-cc30-47f4-b38b-5ddf498e475d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/cda06e67-2f86-4cc1-a0ce-b81bda886d52.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'TOR',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-23T18:00:00Z',
        },
        {
          id: 'ed658aee-3d3b-4f91-8cb4-a7f8b8f34da4',
          results: [
            {
              participants: [
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '88',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
                  value: '103',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
              name: 'Toronto Raptors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2561e3a6-cc30-47f4-b38b-5ddf498e475d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/cda06e67-2f86-4cc1-a0ce-b81bda886d52.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'TOR',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-26T00:00:00Z',
        },
        {
          id: '0a985a91-6e54-4a8f-82e1-6fe9bd9e4640',
          results: [
            {
              participants: [
                {
                  id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
                  value: '97',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '132',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '5a23ac00-7a31-4007-99b7-e928bc9800e0',
              name: 'Toronto Raptors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2561e3a6-cc30-47f4-b38b-5ddf498e475d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/cda06e67-2f86-4cc1-a0ce-b81bda886d52.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'TOR',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-28T23:00:00Z',
        },
      ],
      childObjectId: '345340',
    },
    {
      id: '345348',
      order: 7,
      results: [
        {
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              value: '4',
              drawOrder: 1,
            },
            {
              id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
              value: '0',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
          name: 'Boston Celtics',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'BOS',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
          name: 'Brooklyn Nets',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f76923dc-5bed-45c2-9e65-856f3b3b6b68.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b09ea6ab-b34c-418e-a797-ac26f53ce782.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'BKN',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '4e1f60fb-0b32-4f21-b428-99ecf73e0512',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '115',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
                  value: '114',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
              name: 'Brooklyn Nets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f76923dc-5bed-45c2-9e65-856f3b3b6b68.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b09ea6ab-b34c-418e-a797-ac26f53ce782.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BKN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-17T19:30:00Z',
        },
        {
          id: 'fb84f353-30be-4af7-ad54-6509803c1072',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '114',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
                  value: '107',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
              name: 'Brooklyn Nets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f76923dc-5bed-45c2-9e65-856f3b3b6b68.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b09ea6ab-b34c-418e-a797-ac26f53ce782.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BKN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-20T23:00:00Z',
        },
        {
          id: 'ef9d3308-02a2-494f-9a61-571140522561',
          results: [
            {
              participants: [
                {
                  id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
                  value: '103',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '109',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
              name: 'Brooklyn Nets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f76923dc-5bed-45c2-9e65-856f3b3b6b68.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b09ea6ab-b34c-418e-a797-ac26f53ce782.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BKN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-23T23:30:00Z',
        },
        {
          id: 'db108c57-0f49-4cf8-816a-4f33a594c077',
          results: [
            {
              participants: [
                {
                  id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
                  value: '112',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '116',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'acb5c73e-17f6-4f25-83b8-0722ad4a12da',
              name: 'Brooklyn Nets',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f76923dc-5bed-45c2-9e65-856f3b3b6b68.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b09ea6ab-b34c-418e-a797-ac26f53ce782.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BKN',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-25T23:00:00Z',
        },
      ],
      childObjectId: '345341',
    },
    {
      id: '345349',
      order: 8,
      results: [
        {
          participants: [
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              value: '4',
              drawOrder: 1,
            },
            {
              id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
              value: '1',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
          name: 'Milwaukee Bucks',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MIL',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
          name: 'Chicago Bulls',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c5c87621-adf2-4dad-a512-b9ebd54a29e2.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e6ff432a-1d19-4b0e-98c3-26db3ce28d36.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'CHI',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: 'efc9b14b-54bc-4439-b755-2c0ac2f94cda',
          results: [
            {
              participants: [
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '93',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
                  value: '86',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
              name: 'Chicago Bulls',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c5c87621-adf2-4dad-a512-b9ebd54a29e2.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e6ff432a-1d19-4b0e-98c3-26db3ce28d36.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'CHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-17T22:30:00Z',
        },
        {
          id: 'a1f57390-ff90-4ba4-b331-9d3e926b95c5',
          results: [
            {
              participants: [
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '110',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
                  value: '114',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
              name: 'Chicago Bulls',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c5c87621-adf2-4dad-a512-b9ebd54a29e2.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e6ff432a-1d19-4b0e-98c3-26db3ce28d36.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'CHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-21T01:30:00Z',
        },
        {
          id: '89174465-ce20-4a40-82d6-4d3e4b3d5dc2',
          results: [
            {
              participants: [
                {
                  id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
                  value: '81',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '111',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
              name: 'Chicago Bulls',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c5c87621-adf2-4dad-a512-b9ebd54a29e2.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e6ff432a-1d19-4b0e-98c3-26db3ce28d36.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'CHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-23T00:30:00Z',
        },
        {
          id: 'e9ce7499-d8dd-48bc-a3a3-508d6c99d88a',
          results: [
            {
              participants: [
                {
                  id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
                  value: '95',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '119',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
              name: 'Chicago Bulls',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c5c87621-adf2-4dad-a512-b9ebd54a29e2.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e6ff432a-1d19-4b0e-98c3-26db3ce28d36.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'CHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-24T17:00:00Z',
        },
        {
          id: '635023ad-74ff-4ebd-a698-c281d1413002',
          results: [
            {
              participants: [
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '116',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
                  value: '100',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '95491ffa-0ccc-4c86-90b7-822e8e47341d',
              name: 'Chicago Bulls',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c5c87621-adf2-4dad-a512-b9ebd54a29e2.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/e6ff432a-1d19-4b0e-98c3-26db3ce28d36.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'CHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-04-27T23:30:00Z',
        },
      ],
      childObjectId: '345341',
    },
  ],
  [
    {
      id: '345338',
      order: 1,
      results: [
        {
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              value: '2',
              drawOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              value: '4',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
          name: 'Memphis Grizzlies',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MEM',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
          name: 'Golden State Warriors',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'GSW',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '47e18d25-472b-498a-b12d-8580ca2e5fec',
          results: [
            {
              participants: [
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '116',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '117',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-01T19:30:00Z',
        },
        {
          id: '1b34bd6d-a02c-4c5d-b60e-168a6ccaf500',
          results: [
            {
              participants: [
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '106',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '101',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-04T01:30:00Z',
        },
        {
          id: 'aed259ba-6612-47f4-ba05-bfd9d2535ad2',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '142',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '112',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-08T00:30:00Z',
        },
        {
          id: '60a4d34a-05ae-4825-ae5f-e70dfba8f10d',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '101',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '98',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-10T02:00:00Z',
        },
        {
          id: '5e23c03f-de39-47a6-8c78-613cb28ca8ab',
          results: [
            {
              participants: [
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '134',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '95',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-12T01:30:00Z',
        },
        {
          id: '0823cb30-fc12-4a60-8af6-1c094a47c56f',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '110',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
                  value: '96',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: 'ed2131ce-9f45-4817-ac87-ef44d385d954',
              name: 'Memphis Grizzlies',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/b598feb5-12f6-42d0-a7a8-dbc922f4f4f5.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/c3b0f44e-7a34-47df-8347-7a218fb1b727.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MEM',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-14T02:00:00Z',
        },
      ],
      childObjectId: '345336',
    },
    {
      id: '345339',
      order: 2,
      results: [
        {
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              value: '3',
              drawOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              value: '4',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
          name: 'Phoenix Suns',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'PHX',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
          name: 'Dallas Mavericks',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'DAL',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '3803c7cd-69f6-4aca-a59b-77c9647c4884',
          results: [
            {
              participants: [
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '121',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '114',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-03T02:00:00Z',
        },
        {
          id: 'a868ee20-55ad-49ef-b53a-26c822d3da0a',
          results: [
            {
              participants: [
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '129',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '109',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-05T02:00:00Z',
        },
        {
          id: 'c0419ea9-3587-4db6-a153-3a4ca0c434b3',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '103',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '94',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-07T01:30:00Z',
        },
        {
          id: '89aad005-e2f3-4cd4-9291-342a04d0301d',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '111',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '101',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-08T19:30:00Z',
        },
        {
          id: '4f88c22a-982a-4505-a16a-a42d33e6faa1',
          results: [
            {
              participants: [
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '110',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '80',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-11T02:00:00Z',
        },
        {
          id: 'd426f25b-4e29-43a3-9ad7-fbd3153ed857',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '113',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '86',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-13T01:30:00Z',
        },
        {
          id: '235cbe19-7a75-4265-b990-bf6b940fbadd',
          results: [
            {
              participants: [
                {
                  id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
                  value: '90',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '123',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '323d6db3-56d3-4267-8501-8c7269ed0ede',
              name: 'Phoenix Suns',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/829e7888-c284-4480-b796-f7bc522f524d.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/2843a1cb-cdf0-424d-8441-5e29d1e1826d.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHX',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-16T00:00:00Z',
        },
      ],
      childObjectId: '345336',
    },
    {
      id: '345340',
      order: 3,
      results: [
        {
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              value: '4',
              drawOrder: 1,
            },
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              value: '2',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '6dc732d8-3910-40da-a6ce-ca5741307250',
          name: 'Miami Heat',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MIA',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
          name: 'Philadelphia 76ers',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'PHI',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '8ee7e133-057c-46c1-9d62-717da99e9da9',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '106',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '92',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-02T23:30:00Z',
        },
        {
          id: '6089cf21-725f-43dc-8c06-cd8fbf271fdf',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '119',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '103',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-04T23:30:00Z',
        },
        {
          id: 'cef9f663-29da-4d3b-be6f-9f47e5f83c9e',
          results: [
            {
              participants: [
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '99',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '79',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-06T23:00:00Z',
        },
        {
          id: '99821250-83eb-4610-a117-5a5df022e18b',
          results: [
            {
              participants: [
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '116',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '108',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-09T00:00:00Z',
        },
        {
          id: 'f1cf4481-9469-44de-87f5-e418df009178',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '120',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '85',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-10T23:30:00Z',
        },
        {
          id: '88814fb9-1de7-4292-99b2-5b02f8ae70fc',
          results: [
            {
              participants: [
                {
                  id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
                  value: '90',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '99',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '458ce0c2-a936-4177-ae49-cd6cf571b19b',
              name: 'Philadelphia 76ers',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/85787136-8dc8-4bb0-be3d-8096090345f7.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41036269-41c0-4d76-945e-ced28149eb49.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'PHI',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-12T23:00:00Z',
        },
      ],
      childObjectId: '345337',
    },
    {
      id: '345341',
      order: 4,
      results: [
        {
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              value: '4',
              drawOrder: 1,
            },
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              value: '3',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
          name: 'Boston Celtics',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'BOS',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
          name: 'Milwaukee Bucks',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MIL',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '2ac13dae-7dae-440a-b9d6-b53c5b73f2fd',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '89',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '101',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-01T17:00:00Z',
        },
        {
          id: '9f12bcf0-c04d-43a6-b5c4-86d8d1842efc',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '109',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '86',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-03T23:00:00Z',
        },
        {
          id: '69bc0406-d51f-487e-afdf-970b6dd3dfae',
          results: [
            {
              participants: [
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '103',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '101',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-07T19:30:00Z',
        },
        {
          id: '5020e354-bc95-4e94-bb18-fa48c529ae15',
          results: [
            {
              participants: [
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '108',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '116',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-09T23:30:00Z',
        },
        {
          id: '900af820-9e2c-4419-ae26-5f8c7e0ecca3',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '107',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '110',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-11T23:00:00Z',
        },
        {
          id: 'c5b488e5-5110-4a86-b27d-55d850c6bec7',
          results: [
            {
              participants: [
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '95',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '108',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-13T23:30:00Z',
        },
        {
          id: '5d795106-03d8-4d50-b81c-b74ebdfa16df',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '109',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
                  value: '81',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'c72782c0-a717-4c3e-aa25-9766c9c3296e',
              name: 'Milwaukee Bucks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/41e9356a-aa57-4f99-9b98-61238e6ac440.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d6bae877-9545-4bd6-98d4-b43daf7dbb4b.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-15T19:30:00Z',
        },
      ],
      childObjectId: '345337',
    },
  ],
  [
    {
      id: '345336',
      order: 1,
      results: [
        {
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              value: '4',
              drawOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              value: '1',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
          name: 'Golden State Warriors',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'GSW',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
          name: 'Dallas Mavericks',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'DAL',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '671a9e5b-a7ac-4c8d-9d39-d1733abe2f0d',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '112',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '87',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-19T01:00:00Z',
        },
        {
          id: '976e019e-fd3c-4c85-94ba-b689318bccfc',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '126',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '117',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-21T01:00:00Z',
        },
        {
          id: '3da10070-bcb3-45f0-8094-b6ca183a2a17',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '100',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '109',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-23T01:00:00Z',
        },
        {
          id: '9766d7d2-a215-498c-b417-50d2ebb5ee4d',
          results: [
            {
              participants: [
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '119',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '109',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-25T01:00:00Z',
        },
        {
          id: '02c0c459-a3d0-4d69-a4dd-4b1237aaff7f',
          results: [
            {
              participants: [
                {
                  id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
                  value: '120',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
                  value: '110',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '234fdd21-5758-4a50-b2cc-d3f54bcd9fa2',
              name: 'Golden State Warriors',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/5d1a9fbf-89e1-483d-bbe4-027742d0853e.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/f861bc57-eabe-4fb2-a572-d7d653e63044.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'GSW',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: 'e724da8e-e8e8-458f-865e-d0d64485efb5',
              name: 'Dallas Mavericks',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/14092022/5307b2cc-294f-4338-92b8-bcc106003885.jpeg?operations=fit(150:150)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/834a6e3d-178b-4a41-b227-e817cf0e44ba.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'DAL',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-27T01:00:00Z',
        },
      ],
      childObjectId: '346253',
    },
    {
      id: '345337',
      order: 2,
      results: [
        {
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              value: '3',
              drawOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              value: '4',
              drawOrder: 2,
            },
          ],
          resultType: {
            id: 'd08acffb-b95a-4bcb-a170-76d614e7954a',
            name: 'Total score',
            type: 'TOTALSCORE',
            entityType: 'result_type',
            shortName: '',
          },
        },
      ],
      participants: [
        {
          id: '6dc732d8-3910-40da-a6ce-ca5741307250',
          name: 'Miami Heat',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'MIA',
          entityType: 'team',
          drawOrder: 1,
        },
        {
          id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
          name: 'Boston Celtics',
          gender: 'MALE',
          type: 'CLUB',
          assets: {
            logo: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
            },
            logo150x150: {
              url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
            },
          },
          threeLetterCode: 'BOS',
          entityType: 'team',
          drawOrder: 2,
        },
      ],
      events: [
        {
          id: '6c31aaa5-79e8-4f36-9cf3-bfe7b44408bd',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '118',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '107',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-18T00:30:00Z',
        },
        {
          id: 'e03b62b4-69f7-4e9b-814c-a241bc5cf974',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '102',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '127',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-20T00:30:00Z',
        },
        {
          id: '95d47dba-839c-4ca0-9554-50122ee7972b',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '103',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '109',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-22T00:30:00Z',
        },
        {
          id: 'c49b249c-427e-4c66-916f-255e4de93743',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '102',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '82',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-24T00:30:00Z',
        },
        {
          id: '9057bc50-01f8-4cf6-a05e-db1fd2bc5011',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '80',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '93',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-26T00:30:00Z',
        },
        {
          id: 'abb5a94d-ea44-460a-af69-36ef0f8ba81a',
          results: [
            {
              participants: [
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '103',
                  drawOrder: 2,
                  eventOrder: 1,
                },
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '111',
                  drawOrder: 1,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 1,
            },
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-28T00:30:00Z',
        },
        {
          id: 'e9cd52c2-2c9e-4c03-8808-4e41d3ace8ee',
          results: [
            {
              participants: [
                {
                  id: '6dc732d8-3910-40da-a6ce-ca5741307250',
                  value: '96',
                  drawOrder: 1,
                  eventOrder: 1,
                },
                {
                  id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
                  value: '100',
                  drawOrder: 2,
                  eventOrder: 2,
                },
              ],
              resultType: {
                id: '4',
                name: 'Final Result',
                type: 'FINALRESULT',
                entityType: 'result_type',
                shortName: '',
              },
            },
          ],
          status: {
            id: '6',
            name: 'Finished',
            type: 'FINISHED',
            shortName: 'FIN',
            entityType: 'status',
          },
          participants: [
            {
              id: '6dc732d8-3910-40da-a6ce-ca5741307250',
              name: 'Miami Heat',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/556d4f28-7f6a-4512-8077-a72e06939426.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/87bb3353-fca5-4ee6-8020-d44e5633e8f0.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'MIA',
              entityType: 'team',
              drawOrder: 1,
              eventOrder: 1,
            },
            {
              id: '348a9f6d-ae15-453b-a65e-ba2d5106dc1b',
              name: 'Boston Celtics',
              gender: 'MALE',
              type: 'CLUB',
              assets: {
                logo: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/d7b5ad39-557a-42b3-8c6c-362e9ef4eb84.png?operations=fit(70:70)',
                },
                logo150x150: {
                  url: 'https://image.api.integration.sportal365.com//process/smp-image-api-integration/basketball/01112022/4dd59436-59ad-426a-82a1-01bdf01c2764.png?operations=fit(150:150)',
                },
              },
              threeLetterCode: 'BOS',
              entityType: 'team',
              drawOrder: 2,
              eventOrder: 2,
            },
          ],
          scheduledStartTime: '2022-05-30T00:30:00Z',
        },
      ],
      childObjectId: '346253',
    },
  ],
];
